import LeftHeaderContainer from './LeftHeaderContainer';

export default LeftHeaderContainer;